export default __webpack_public_path__ + "static/media/push.52401158.svg";